import { render, staticRenderFns } from "./PTableMultilevel.vue?vue&type=template&id=4df15b52&"
import script from "./PTableMultilevel.vue?vue&type=script&lang=ts&"
export * from "./PTableMultilevel.vue?vue&type=script&lang=ts&"
import style0 from "./PTableMultilevel.vue?vue&type=style&index=0&id=4df15b52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports